import {
  Link,
  Outlet,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { useState, useRef, useEffect } from "react";
import "./Committeegnb.scss";
function Committeegnb() {
  let navigate = useNavigate();
  const { id } = useParams();
  const [commpageId, setCommpageId] = useState([]);
  const heighL = useRef();
  const btnWidth = useRef();
  const location = useLocation();

  // 탭 onClick 이벤트 이슈 대응
  useEffect(() => {
    if (location.pathname.includes("info")) {
      sliding(btnWidth.current.offsetWidth);
    }
    if (location.pathname.includes("member")) {
      sliding(btnWidth.current.offsetWidth * 2);
    }
  }, [location]);

  useEffect(() => {
    heighL.current.style.width = btnWidth.current.offsetWidth + "px";
    heighL.current.style.height = btnWidth.current.offsetHeight + "px";
  });

  useEffect(() => {
    let commpage = JSON.parse(window.sessionStorage.getItem("commpage"));
    commpage.map((value) => {
      if (value.id === id) {
        setCommpageId(id);
      }
    });
  }, [id]);

  function sliding(val) {
    heighL.current.style.left = val + "px";
  }
  return (
    <>
      {/* <Link to="/breakdown/cits/mytabcits">C-ITS인증</Link>
      <Link to="/breakdown/cits/mytabcits2">시험소인정</Link>
      <Link to="/breakdown/cits/mytabcits3">AVI, VDS 성능평가</Link> */}

      <div className="tab_btns_wrap">
        <div className="tab_btns">
          <Link
            to={`/committeeprocess/${commpageId}`}
            className="tabBtn"
            ref={btnWidth}
            onClick={() => {
              sliding(0);
            }}
          >
            회의일정
          </Link>
          <Link
            to={`/committeeprocess/${commpageId}/info`}
            className="tabBtn"
            ref={btnWidth}
            onClick={(e) => {
              sliding(btnWidth.current.offsetWidth);
              // console.log(e.target);
            }}
          >
            회의정보
          </Link>

          <Link
            to={`/committeeprocess/${commpageId}/member`}
            className="tabBtn"
            ref={btnWidth}
            onClick={() => {
              sliding(btnWidth.current.offsetWidth * 2);
            }}
          >
            구성원정보
          </Link>
        </div>
        <span ref={heighL} className="hL"></span>
      </div>
      {/* <Outlet></Outlet> */}
    </>
  );
}

export default Committeegnb;
